<template>
    <div class="margin-neg">
        <b-row>
            <b-col sm="2">
                <b-form-group
                        id="abteilung"
                        label="Abteilung"
                        label-for="abteilung-select"
                >
                    <b-form-select id="abteilung-select"
                                   :plain="true"
                                   :options="userGroups"
                                   v-model="selectedAbteilung"
                                   size="sm">
                    </b-form-select>

                </b-form-group>
            </b-col>
            <b-col sm="2">
                <b-form-group
                        id="search-type"
                        label="Suchart"
                        label-for="search-type-select"
                >
                    <b-form-select id="search-type-select"
                                   :plain="true"
                                   :options="searchTypes"
                                   v-model="selectedSearchType"
                                   size="sm">
                    </b-form-select>

                </b-form-group>
            </b-col>
            <b-col sm="1" v-if="showYear">
                <b-form-group
                        :disabled="allYears"
                        id="year"
                        label="Für das Jahr"
                        label-for="year-input"
                        style="white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;"
                >
                    <b-form-input
                            :disabled="allYears"
                            id="year-input"
                            type="number"
                            v-model="selectedYear"
                            placeholder="2019"
                            size="sm">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="1" v-if="showYear" style="padding-top: 2rem">
                <b-form-checkbox
                        id="checkbox-1"
                        v-model="allYears"
                        name="checkbox-1"
                >
                    Alle Jahre
                </b-form-checkbox>
            </b-col>

            <b-col sm="1" style="padding-bottom: 1rem">
                <!--b-button
                        style="position:absolute; bottom:1rem; left:12px;"
                        v-on:click="searchFilter"
                        size="sm"
                          variant="primary"
                        class="px-2 mr-3 mt-auto">Anwenden
                </b-button-->
            </b-col>

            <b-col sm="2" class="ml-auto" style="padding-bottom: 1rem"
                   v-on:keypress.enter="searchText">
                <b-form-input
                        style="position:absolute; bottom:1rem; left:0;"
                        v-model="fullTextSearch"
                        placeholder="Suche"></b-form-input>
            </b-col>
            <b-col sm="1" style="padding-bottom: 1rem">
                <b-button style="position:absolute; bottom:1rem; left:12px;"
                          v-on:click="searchText"
                          variant="primary"
                          class="px-4 mr-3 mt-auto">Suchen
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        props: {
            onSearch: {
                type: Function,
                default: undefined
            },
            userGroups: {
                type: Array,
                default: () => []
            },
            userGroupSelect: {
                default: () => undefined
            },
            isEncrypted: {
                type: Boolean,
                default: () => false
            }
        },
        name: "searchbar",
        computed: {
            showYear() {
                return true;
            },
        },
        data: () => {
            return {
                fullTextSearch: "",
                selectedAbteilung: "Alle Aufträge",
                selectedSearchType: "A",
                selectedYear: new Date().getFullYear(),
                searchTypes: [
                    {text: "Alle Anfragen", value: "A"},
                    {text: "Anfragen an mich", value: "M"}],
                loader: undefined,
                wasMounted: false,
                allYears: true,
            }
        },
        methods: {
            searchText() {
                if (this.onSearch !== undefined) {
                    this.onSearch(
                        this.selectedSearchType,
                        this.selectedAbteilung,
                        this.allYears ? -1 : this.selectedYear,
                        this.fullTextSearch
                    )
                }
            },
            searchFilter() {
                if (this.onSearch !== undefined) {
                    this.onSearch(
                        this.selectedSearchType,
                        this.selectedAbteilung,
                        this.allYears ? -1 : this.selectedYear,
                        this.fullTextSearch
                    )
                }
            },
            onFirstSearch() {
                this.wasMounted = true;
            }
        },
        watch: {
            userGroupSelect: function(newVal, oldVal) {
                this.selectedAbteilung = newVal;
            },
            selectedAbteilung: function(newVal, oldVal) {
                if (this.wasMounted) {
                    this.searchFilter();
                }
            },
            selectedSearchType: function(newVal, oldVal) {
                if (this.wasMounted) {
                    this.searchFilter();
                }
            },
            selectedYear: function(newVal, oldVal) {
                if (this.wasMounted) {
                    this.searchFilter();
                }
            },

            allYears: function(newVal, oldVal) {
                if (this.wasMounted) {
                    this.searchFilter();
                }
            }
        }
    }
</script>

<style scoped>
    .margin-neg {
        background: #fbfbfb;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 1rem;
    }
    .form-control {
        color: black;
    }
</style>
